import { baseThemeValues } from 'constants/common';

export const tooltipTheme = {
  arrowColor: 'palette.primary.20',
  bg: 'palette.tertiary.95',
  borderColor: 'palette.primary.20',
  borderRadius: '8px',
  borderWidth: '1px',
  fontFamily: baseThemeValues.inherit,
  fontSize: '12px',
  fontWeight: 400,
  text: 'palette.tertiary.5',
};
